/**
 * Fime – Major Challenges Accordion (Expertise template)
 *
 * Desktop: all items closed by default.
 * Mobile (<lg): first item open by default.
 * Only one item open at a time — opening a new one closes the
 * current, animated purely via CSS grid-rows transition; this script
 * just toggles the .is-open class.
 */

const mcAccordionItems = document.querySelectorAll('.mc-accordion-item');

function setMcDefaultState() {
	const isMobile = window.innerWidth < 1024;
	mcAccordionItems.forEach(function (item) {
		const shouldBeOpen = isMobile && item.dataset.mobileOpen === 'true';
		item.classList.toggle('is-open', shouldBeOpen);
	});
}

setMcDefaultState();

// Re-evaluate default state on resize crossing the lg breakpoint
// (only applies before the user has manually interacted — once they
// click anything, normal accordion behavior takes over regardless).
let mcHasInteracted = false;

window.addEventListener('resize', function () {
	if (!mcHasInteracted) setMcDefaultState();
});

mcAccordionItems.forEach(function (item) {
	const trigger = item.querySelector('.mc-accordion-trigger');

	trigger.addEventListener('click', function () {
		mcHasInteracted = true;
		const isOpen = item.classList.contains('is-open');

		mcAccordionItems.forEach(function (otherItem) {
			otherItem.classList.remove('is-open');
		});

		if (!isOpen) {
			item.classList.add('is-open');
		}
	});
});
